module.exports = __webpack_public_path__ + "img/DE03515.26c7bbaa.png";